import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import { Container } from '@/components/generals/container'
import { HalftoneImage } from '@/components/dots/halftone-image'
import { SilkDrift } from '@/components/dots/silk-drift'
import { TESTIMONIAL } from '@/constants/content'

export const TestimonialSection: FC = (): ReactNode => {
    return (
        <section id='testimonial' aria-label="Client testimonial" className='relative isolate border-t border-line bg-mist'>
            <SilkDrift />

            <Container className='grid items-center gap-12 py-24 md:py-32 lg:grid-cols-12 lg:gap-16'>
                <Reveal className='lg:col-span-4'>
                    <div className='relative aspect-square w-full max-w-[22rem] overflow-hidden border border-line bg-white'>
                        <HalftoneImage
                            src={TESTIMONIAL.image}
                            alt={TESTIMONIAL.imageAlt}
                            focusY={0.2}
                            cell={5}
                            mobileCell={4}
                            sizes='(min-width: 1024px) 22rem, 80vw'
                            className='absolute inset-0'
                        />
                    </div>
                </Reveal>

                <figure className='lg:col-span-8'>
                    <Reveal delay={120}>
                        <span aria-hidden='true' className='block text-7xl leading-none font-medium text-azure-500'>
                            “
                        </span>

                        <blockquote className='mt-2'>
                            <p className='text-[clamp(1.6rem,3vw,2.75rem)] font-medium leading-[1.15] tracking-[-0.03em] text-ink'>
                                {TESTIMONIAL.quote}
                            </p>
                        </blockquote>

                        <figcaption className='mt-10 flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-line pt-6'>
                            <span aria-hidden='true' className='size-2 bg-azure-500' />
                            <span className='font-medium text-ink'>{TESTIMONIAL.name}</span>
                            <span className='font-mono text-[11px] uppercase tracking-[0.14em] text-muted-foreground'>
                                {TESTIMONIAL.role}
                            </span>
                        </figcaption>
                    </Reveal>
                </figure>
            </Container>
        </section>
    )
}
